import React, { FunctionComponent, useEffect, useState } from 'react';
// import { useTheme } from '@mui/material/styles';
import { useAtom } from 'jotai';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next'

import { fetch_one } from '../../lib/server_helper';

import {
  Box,
  Divider,
  Grid
} from '@mui/material';

import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

import { loginAtom } from '../../lib/auth';

import { AlertCheckInputs } from '../../components/alerts/CheckInputs';
import { AlertSaved } from '../../components/alerts/Saved';
import { AlertSomethingWentWrong } from '../../components/alerts/SomethingWentWrong';

import {
  Page,
  StyledButton,
  StyledTextField,
  Typography
} from '../../components/interface';
import { PickersCompanyPicker } from '../../components/pickers/CompanyPicker';

import { User } from '../../models/User';

// const { DateTime } = require("luxon");

// type AvailableLang = 'nl' | 'fr' | 'en';
type Props = {};

export const AdminOrganiserDetail: FunctionComponent<Props> = () => {
  const navigate = useNavigate();
  // const theme = useTheme();
  const {t, i18n} = useTranslation(['translations']);

  const params = useParams();

  const [login, setLogin] = useAtom(loginAtom);
  const [embeddableDetail, setEmbeddableDetail] = useState<User|null>(null);
  const [loader, setLoader] = useState<boolean>(true);
  const [saveLoader, setSaveLoader] = useState<boolean>(false);
  const [objectId, setObjectId] = useState<string | undefined>(params.id);

  const [firstName, setFirstName] = useState<string>('');
  const [lastName, setLastname] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [companyId, setCompanyId] = useState<number>();

  const [errorSnackOpen, setErrorSnackOpen] = useState<boolean>(false);
  const [serverErrorSnackOpen, setServerErrorSnackOpen] = useState<boolean>(false);
  const [exitSavedSnackOpen, setDividendSavedSnackOpen] = useState<boolean>(false);

  const fields = [
    'id', 'created_at', 'updated_at', 'first_name', 'last_name', 'email', 'company_id'
  ];


  const fetchCalculation = () => {
    setLoader(true);
    
    fetch_one<User>('/nl/v3/objects/fetch_all', {
      object: 'user',
      fields: fields,
      id: objectId
    }, (ob, complete_data) => {
      setFirstName(ob.first_name || '');
      setLastname(ob.last_name || '');
      setEmail(ob.email || '');
      setCompanyId(!!ob.company_id ? parseInt(ob.company_id.toString(), 10) :  undefined);
      setLoader(false);
    }, (z) => {
      setServerErrorSnackOpen(true);
    }, (!!login?.auth_token ? {auth_token: login?.auth_token, email: login?.email} : undefined));
  };
  const saveSetting = (isRemove:boolean) => {
    setSaveLoader(true);

    fetch_one<User>('/nl/v3/objects/custom_action', {
      object: 'user',
      class_action: 'custom_api_invite_admin',
      ob: {
        first_name: firstName,
        last_name: lastName,
        email: email,
        is_organiser: true,
        company_id: companyId
      },
      ...(!!isRemove ? {
        downgrade: true
      } : {})
    }, (ob, complete_data) => {
      navigate(`/organisers`);
    }, (z) => {
      setServerErrorSnackOpen(true);
    }, (!!login?.auth_token ? {auth_token: login?.auth_token, email: login?.email} : undefined));
  };




  useEffect(() => {
    fetchCalculation();
  }, []);



  return (
    <Page sx={{}} title={t("invite.admin")}>
      <Grid container spacing="8">

        <Grid item container xs={12} spacing="4" sx={{alignContent: 'baseline'}}>
          <Grid item xs={12} sx={{marginBottom: 2}}>
            <Box sx={{padding: 2, backgroundColor: 'rgba(0, 255, 0, 0.1)'}}>
              <Typography>If the given email exists already, the user will become an organiser. If the user does not exist, a blank user will be created.</Typography>
            </Box>
          </Grid>

          <Grid item xs={6}>
            <StyledTextField
              label="First name"
              value={firstName || ''}
              id="fn"
              onChange={(v) => {setFirstName(v);}}
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <StyledTextField
              label="Last name"
              value={lastName || ''}
              id="ln"
              onChange={(v) => {setLastname(v);}}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <StyledTextField
              label="Email"
              value={email || ''}
              id="email"
              type="email"
              onChange={(v) => {setEmail(v);}}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <PickersCompanyPicker
              value={companyId?.toString() || ''}
              onChange={(ob) => {
                setCompanyId(parseInt(ob, 10));
              }}
            />
          </Grid>
        </Grid>

        <Grid item xs={12} sx={{alignContent: 'baseline', textAlign: 'center', position: 'sticky', bottom: 0, backgroundColor: 'white', zIndex: 1201}}>
          <Divider sx={{marginTop: 1, marginBottom: 2}} />

          {!!objectId && <StyledButton
            label={t("public.buttons.remove_as_organiser", "Verwijderen als organiser")}
            id='remove_as_organiser'
            // contained
            onClick={(v) => {
              saveSetting(true);
            }}
            sx={{marginLeft: 1}}
          />}
          {<StyledButton
            label={t("public.buttons.cancel")}
            id='cancel'
            // contained
            onClick={(v) => {
              navigate(`/organisers`);
            }}
            sx={{marginLeft: 1}}
          />}
          {<StyledButton
            label={t("public.buttons.save")}
            id='save'
            disabled={!firstName || !lastName || !email || !companyId}
            contained
            onClick={(v) => {
              saveSetting(false);
            }}
            sx={{marginLeft: 1}}
          />}
        </Grid>
      </Grid>

      {!!serverErrorSnackOpen && <AlertSomethingWentWrong open={serverErrorSnackOpen} setOpen={(b) => {setServerErrorSnackOpen(b);}} />}
      {!!errorSnackOpen && <AlertCheckInputs open={errorSnackOpen} setOpen={(b) => {setErrorSnackOpen(b);}} />}
      {!!exitSavedSnackOpen && <AlertSaved open={exitSavedSnackOpen} setOpen={(b) => {setDividendSavedSnackOpen(b);}} />}
    </Page>
  );
}
